import { GetRequest } from "./RequestTemplates";

export type TariffT = {
  id: number;
  isBasicTariff: boolean;
  name: { text: string };
  permanentId: number;
  shortName: { text: string };
};

export type TariffsResponse = Array<TariffT>;

export type CurrentPriceResponse = {
  fixedCosts: number;
  isBasicTariff: boolean;
  pricePerUnit: number;
  totalCostAmount: number;
  usageCosts: number;
  currentPriceType: string;
};

export const fetchTariffs = async (
  categoryType: string,
  categoryProviderId: string,
  postalcode: string,
  locationId: number,
  isCompany: boolean
): Promise<TariffsResponse> => {
  return GetRequest(`${process.env.API_SERVER_URL}/provider/categoryProviderTariffs/${categoryProviderId}`, {
    params: {
      propertyType: isCompany ? "COMPANY" : undefined,
      postcode: postalcode,
      locationId: locationId,
    },
  }).then((res) => {
    const customPricesTariff: TariffT = {
      id: -9999,
      isBasicTariff: false,
      name: { text: "Jetzt eigene Tarif-Preise angeben!" },
      permanentId: -9999,
      shortName: { text: "Jetzt eigene Tarif-Preise angeben!" },
    };

    const tariffs = res.data;

    if (!tariffs.length) {
      tariffs.push(customPricesTariff);
    } else {
      tariffs.splice(1, 0, customPricesTariff);
    }

    return tariffs;
  });
};

export const fetchCurrentPrices = async (
  categoryType: "GAS" | "ELECTRICITY",
  postalcode: string,
  locationId: number,
  yearlyConsumption: number,
  tariffId?: number,
  permanentTariffId?: number
): Promise<CurrentPriceResponse[]> => {
  return GetRequest(`${process.env.API_SERVER_URL}/current-prices`, {
    params: {
      category: categoryType,
      postCode: postalcode,
      locationId: locationId,
      yearlyConsumption: yearlyConsumption,
      tariffId: tariffId || "",
      permanentTariffId: permanentTariffId || "",
    },
  }).then((res) => res.data);
};

export const fetchCurrentPrice = async (
  categoryType: "GAS" | "ELECTRICITY",
  postalcode: string,
  locationId: number,
  yearlyConsumption: number,
  tariffId?: number,
  permanentTariffId?: number
): Promise<CurrentPriceResponse> => {
  return GetRequest(`${process.env.API_SERVER_URL}/current-price`, {
    params: {
      category: categoryType,
      postCode: postalcode,
      locationId: locationId,
      yearlyConsumption: yearlyConsumption,
      tariffId: tariffId || "",
      permanentTariffId: permanentTariffId || "",
    },
  }).then((res) => res.data);
};

export const getPriceScale = async (
  postCode: string,
  category: string,
  locationId?: number,
  yearlyConsumption?: number,
  profileType: "PRIVATE" | "BUSINESS" = "PRIVATE",
  contractEndDate?: string
): Promise<CurrentPriceResponse> => {
  let queryParams = `?postCode=${postCode}&category=${category}&profileType=${profileType}`;
  if (yearlyConsumption) queryParams += `&yearlyConsumption=${yearlyConsumption}`;
  if (locationId) queryParams += `&locationId=${locationId}`;
  if (contractEndDate) queryParams += `&contractEndDate=${contractEndDate}`;

  return GetRequest(`${process.env.API_SERVER_URL}/price-scale-provider/price-scale/unit${queryParams}`).then(
    (res) => res.data
  );
};

export const getTariff = async (id: string) => {
  return GetRequest(`${process.env.API_SERVER_URL}/tariff/${id}`).then((res) => res.data);
};

export const getTariffHistory = async (id: string) => {
  return GetRequest(`${process.env.API_SERVER_URL}/tariff/change-service/${id}`).then((res) => res.data);
};
